import { coreApi } from "./coreApi";

export const offersApi = coreApi.injectEndpoints({
    endpoints: (builder) => ({
        // Get all offers (for listing)
        getOffers: builder.query({
            query: (query = "") => ({
                url: `/administrator/promotions${query ? `?${query}` : ""}`,
                method: "GET",
            }),
            providesTags: ["Offers"],
        }),

        // Get single offer by ID (for editing)
        getOffer: builder.query({
            query: (id) => ({
                url: `/administrator/promotions/show/${id}`,
                method: "GET",
            }),
            providesTags: (result, error, id) => [{ type: "Offers", id }],
        }),

        // Get offer types and gift types (for create form)
        getOfferTypes: builder.query({
            query: () => ({
                url: `/administrator/promotions/create`,
                method: "GET",
            }),
        }),

        // Get stores list
        getStores: builder.query({
            query: () => ({
                url: `/administrator/stores`,
                method: "GET",
            }),
            providesTags: ["Stores"],
        }),

        // Create new offer
        createOffer: builder.mutation({
            query: (data) => ({
                url: `/administrator/promotions/store`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Offers"],
        }),

        // Update existing offer
        updateOffer: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `/administrator/promotions/update/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: (result, error, { id }) => [
                "Offers",
                { type: "Offers", id },
            ],
        }),

        // Get products by store
        getProductsByStore: builder.query({
            query: (storeId) => ({
                url: storeId
                    ? `/administrator/stores/${storeId}/products`
                    : `/administrator/products?per_page=100`,
                method: "GET",
            }),
        }),

        // Delete offer
        deleteOffer: builder.mutation({
            query: (id) => ({
                url: `/administrator/promotions/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Offers"],
        }),
    }),
});

export const {
    useGetOffersQuery,
    useGetOfferQuery,
    useGetOfferTypesQuery,
    useGetStoresQuery,
    useCreateOfferMutation,
    useUpdateOfferMutation,
    useDeleteOfferMutation,
    useGetProductsByStoreQuery,
} = offersApi;
